import React from "react";
import { Link } from 'react-router-dom'
import "../App.css";
import CommentingList from "./CommentingList.jsx";

export default class CommentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      post_text: "",
      postmessage: "",
      avatarUrl: "",
      sortbyHidden: true,
      sortValue: "Recent"
    };
    this.postListing = React.createRef();
  }
  displaySortByFilters(){
    this.setState({
      sortbyHidden: !this.state.sortbyHidden
    })
    
  }

  filterRecent= event =>{
    event.preventDefault();
    
    this.setState({
      sortValue: "Recent",
      sortbyHidden: !this.state.sortbyHidden
    }, () =>{
      this.postListing.current.loadPosts();
    })
  }

  filterOldest= event =>{
    event.preventDefault();
    this.setState({
      sortValue: "Oldest",
      sortbyHidden: !this.state.sortbyHidden
    }, () =>{
      this.postListing.current.loadPosts();
    })
  }

  filterLikes= event =>{
    event.preventDefault();
    this.setState({
      sortValue: "Most Likes",
      sortbyHidden: !this.state.sortbyHidden
    })
  }
  
  submitHandler = event => {
    //keep the form from actually submitting
    event.preventDefault();
    //make the api call to the authentication page
    fetch(process.env.REACT_APP_API_PATH+"/posts", {
      method: "post",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
      },
      body: JSON.stringify({
        authorID: sessionStorage.getItem("user"),
        content: this.state.post_text,
        parentID: this.props.parent,
        thumbnailURL: "",
        type: "post"
      })
    })
      .then(res => res.json())
      .then(
        result => {
          // update the count in the UI manually, to avoid a database hit
          this.props.onAddComment(this.props.commentCount + 1);
          this.postListing.current.loadPosts();
          this.setState({
            post_text:""
          })
        },
        error => {
          console.log("error!");
        }
      );
  };
  componentDidMount() {
    console.log("In profile");
    console.log(this.props);
    fetch(process.env.REACT_APP_API_PATH+"/users/"+sessionStorage.getItem("user"), {
      method: "get",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+sessionStorage.getItem("token")
      }
    })
      .then(res => res.json())
      .then(
        result => {
          if (result) {
            console.log(result);
            if (result.attributes){
            this.setState({
              avatarUrl: result.attributes.pfp 
            });
          }
          }
        },
        error => {
          console.log("error!");
        }
      );
  }
  myChangeHandler = event => {
    this.setState({
      post_text: event.target.value
    });
  };
  render() {
    return (
      <div className="commentDiv">
        <form className="commentSubmit" onSubmit={this.submitHandler}>
          <Link to={"/user/"+sessionStorage.getItem("user")}>
        <img alt='avatar for user currently logged in' className="commentpfp" src={this.state.avatarUrl} ></img>
            </Link><textarea className="addCommentBox" placeholder="Add a comment..." onChange={this.myChangeHandler} value={this.state.post_text}/>
          <br />
          <input className = "commentButton" type="submit" value="Comment!"/>
          <br />
          {this.state.postmessage}
        </form>
        <div className="commentsAndSort"><div className="commentsHeader">Comments</div>
        <div className="sortbyBox2">
              <label>Sort By: </label>
              <div className="sortByDropdown2">
                {this.state.sortbyHidden &&
                <button class="sortbyButton2" onClick={this.displaySortByFilters.bind(this)}>{this.state.sortValue}</button>
                }
                {!this.state.sortbyHidden &&
                  <div class="sortByFilters2"><a href="#" className="topfilter" onClick={this.filterRecent.bind(this)}>Recent</a><a href="#" onClick={this.filterOldest.bind(this)}>Oldest</a></div>
                }
              </div>
            </div>
        </div>
        
        <CommentingList
          sortValue = {this.state.sortValue}
          ref={this.postListing}
          parentid={this.props.parent}
          type="commentlist"
        />
      </div>
    );
  }
}